import ProductNewForm from "../Components/ProductNewForm.js"

function New(){

    return(
        <div
            className="New"> <ProductNewForm />
        </div>
    );
}

export default New;